import type { Turn } from "./types";

/**
 * A scripted call, kept for `?states`.
 *
 * It used to be what pressing Call it live played, because nothing was
 * connected; the real thing is `session.ts` now. What is left is the three
 * lines the states bar fills the transcript with, so every screen can still be
 * looked at without spending a demo call on it.
 */
const SCRIPT: Turn[] = [
  {
    who: "her",
    text: "Hi, you've reached the hire desk. Are you after a quote, or would you like to leave a message for the team?",
  },
  {
    who: "you",
    text: "A quote, please. A PA for a birthday on Saturday, about eighty people.",
  },
  { who: "her", text: "Lovely. Is it indoors or outdoors, and whereabouts is the venue?" },
];

/** The three lines, whole — what ?states fills the transcript with. */
export const SAID: Turn[] = SCRIPT.map((line) => ({ ...line }));
